import React, {useEffect, useState} from "react";
import { Box, Button, CardActions, CardContent, TextField } from "@mui/material";
import {deleteCurrency, saveCurrency} from "../../store/currencySlice";
import {useDispatch} from "react-redux";
import ViewAndEditFormLayout from "./ViewAndEditFormLayout";
import {useTranslation} from "react-i18next";



const EditCurrencyForm = ({currency, onCancel}) => {
    const {t} = useTranslation();
    const DEFAULT_ERRORS = {name: null, shortName: null};
    const dispatch = useDispatch();
    const [name, setName] = useState(currency.name);
    const [shortName, setShortName] = useState(currency.shortName);
    const [code, setCode] = useState(currency.code);
    const [errors, setErrors] = useState(DEFAULT_ERRORS);

    useEffect(() => {
        setName(currency.name);
        setShortName(currency.shortName);
        setCode(currency.code);
        setErrors(DEFAULT_ERRORS);
    }, [currency]);

    const validateForm = () => {
        const nextErrors = {
            name: !name || !name.trim() ? "Name is required" : null,
            shortName: !shortName || !shortName.trim() ? "Short name is required" : null
        };
        setErrors(nextErrors);
        return !nextErrors.name && !nextErrors.shortName;
    };

    const editContent = ({ onCancel: handleCancel, onSave: handleSave }) => (
        <>
            <CardContent>
                <Box sx={{ m: 2 }}>
                    <TextField
                        id="name"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            setErrors(prev => ({ ...prev, name: null }));
                        }}
                        label={t("common.labels.name")}
                        variant="standard"
                        sx={{ width: "50%" }}
                        error={!!errors.name}
                        helperText={errors.name}
                    />
                </Box>
                <Box sx={{ m: 2 }}>
                    <TextField
                        id="shortName"
                        value={shortName}
                        onChange={(e) => {
                            setShortName(e.target.value);
                            setErrors(prev => ({ ...prev, shortName: null }));
                        }}
                        label={t("common.labels.shortName")}
                        variant="standard"
                        sx={{ width: "50%" }}
                        error={!!errors.shortName}
                        helperText={errors.shortName}
                    />
                </Box>
                <Box sx={{ m: 2 }}>
                    <TextField
                        id="code"
                        value={code || ""}
                        onChange={(e) => setCode(e.target.value)}
                        label={t("common.labels.code")}
                        variant="standard"
                        sx={{ width: "50%" }}
                    />
                </Box>
            </CardContent>
            <CardActions sx={{ ml: "2rem", mb: "1rem", mt: "1rem", mr: "2rem", height: "4rem" }}>
                <Box sx={{ position: "relative", width: "100%" }}>
                    <Box sx={{ position: "absolute", left: 0 }}>
                        <Button variant="outlined" sx={{ mr: "1rem" }} onClick={handleCancel}>{t("common.buttons.cancel")}</Button>
                        <Button variant="contained" onClick={handleSave}>{t("common.buttons.save")}</Button>
                    </Box>
                    {currency.id && (
                        <Box sx={{ position: "absolute", right: 0 }}>
                            <Button variant="outlined" color="error" onClick={() => dispatch(deleteCurrency(currency, () => onCancel()))}>
                                {t("common.buttons.delete")}
                            </Button>
                        </Box>
                    )}
                </Box>
            </CardActions>
        </>
    );

    return (
        <ViewAndEditFormLayout
            editTitle={currency.id ? t("forms.currency.editTitle") : t("forms.currency.createTitle")}
            viewTitle={currency.id ? t("forms.currency.editTitle") : t("forms.currency.createTitle")}
            initialEdit={true}
            onCancel={onCancel}
            onSave={() =>
                validateForm() && dispatch(
                    saveCurrency(
                        { ...currency, name: name.trim(), shortName: shortName.trim(), code: (code || "").trim() },
                        () => onCancel()
                    )
                )
            }
            onDelete={currency.id ? () => dispatch(deleteCurrency(currency, () => onCancel())) : undefined}
            editContent={editContent}
            viewContent={null}
        />
    );
}
export default EditCurrencyForm